import axios from 'axios';

const SITENAME = window.location.pathname.split('/')[2];
const BASE_URL = '/security/customer';
const BUYER_URL = '/buyer/api/v1';
const ONE_ID_BASE_URL = `${window.location.origin}/auth/api/v1`;
const BUYER_PASSTHROUGH_URL = '/buyer/api/v1';
const SECURITY_PASSTHROUGH_URL = `/auth/api/v1/passthrough/security/customer/${SITENAME}`;

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosBuyer = axios.create({
  baseURL: BUYER_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const axiosBuyerPassthrough = axios.create({
  baseURL: BUYER_PASSTHROUGH_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

axiosBuyerPassthrough.interceptors.request.use((config) => {
  const role = sessionStorage.getItem(`${SITENAME}.role`);
  if (role) {
    config.headers['x-user-context'] = role;
  } else {
    delete config.headers['x-user-context'];
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const axiosSecurity = axios.create({
  baseURL: BASE_URL,
});

export const axiosSecurityPassthrough = axios.create({
  baseURL: SECURITY_PASSTHROUGH_URL,
  withCredentials: true
});


export const axiosOneId = axios.create({
  baseURL: ONE_ID_BASE_URL,
  withCredentials: true
});
